/* Selector de variantes con imagen. Reimplementa en cliente la lógica que en el
   theme original vivía en Liquid, para poder probarlo como variación sin tocar
   el theme. Las imágenes salen de datos reales de la tienda: la foto de la
   variante o la del producto hermano. Nada hardcodeado. */
(function () {
  'use strict';

  /* ---- CONFIG: lo único que hay que tocar por cliente ---- */
  var CFG = {
    // Fila de cada opción de variante y sus botones. Sabor es siempre la
    // primera opción real de Shopify en este theme (data-option-index="0");
    // Cantidad y Formato no son opciones de Shopify, son productos
    // vinculados con sus propios data-linked-*, así que quedan fuera.
    optionRow: '.ers-pdp__option-group[data-option-index="0"]',
    optionSwatch: '.ers-pdp__option-group[data-option-index="0"] .ers-pdp__variant-pill',
    // Esta tienda no separa sabores en productos hermanos: Sabor es una
    // opción de variante normal dentro del mismo producto.
    familyRow: null,
    familySwatch: null,
    // Clase que marca la opción activa en este theme.
    activeClass: 'is-active',
    // Cómo leer la etiqueta visible de un swatch. data-option-display trae
    // el valor formateado tal cual lo espera product.variants[i].options
    // (data-option-value viene en minúsculas y no siempre coincide).
    label: function (el) {
      return (el.getAttribute('data-option-display') || el.getAttribute('data-option-value') || el.textContent || '').trim();
    },
    // Respaldo de color por etiqueta, para el fondo mientras carga la foto.
    // Tomado del punto de color que el theme ya pinta hoy en HIGH ENERGY GEL
    // 76g. No es exhaustivo: sabores de otros productos que no se han
    // verificado aquí simplemente caen al gris por defecto de la baldosa,
    // sin impacto porque esos productos ya tienen imagen por variante.
    colorMap: {
      'Speculoos Salado': '#8D5524',
      'Lima - Cafeína': '#6D9B3A',
      'Cereza - Cafeína': '#7B1024',
      'Cacahuete Salado y Miel': '#C49A5C',
      'Café Expreso - Cafeína': '#4E342E',
      'Fresa Salada': '#E06080',
      'Grosella Negra y BCAA': '#4A0E4E',
      'Limón': '#DAE934',
      'Neutro': '#D6CFC4',
      'Plátano': '#F9E44C'
    },
    size: 88
  };

  // Los ajustes viven en atributos data-* de un marcador en el HTML (ver
  // sección "Producto principal"), no en variables cacheadas: así se leen
  // frescos en cada ejecución, incluida la recarga en vivo del editor al
  // cambiar un ajuste, que sustituye el HTML pero no vuelve a ejecutar
  // <script>. Todo pasa por esta única función.
  function configEl() {
    return document.getElementById('cro-swatch-config');
  }
  function settingEnabled() {
    var el = configEl();
    return !!el && el.dataset.enabled === 'true';
  }
  function settingLayout() {
    var el = configEl();
    return el ? el.dataset.layout : 'grid';
  }
  function settingOverrides() {
    var el = configEl();
    if (!el) { return {}; }
    try { return JSON.parse(el.dataset.overrides || '{}'); } catch (e) { return {}; }
  }

  // Dentro del propio editor de temas, el ajuste del bloque manda siempre:
  // nada de overrides de localStorage de una sesión de prueba anterior, para
  // que el Personalizador sea fiel a lo que está seleccionado ahí mismo.
  function inThemeEditor() {
    return typeof window.Shopify !== 'undefined' && window.Shopify.designMode === true;
  }

  // Switch desactivado por defecto: en el theme de borrador, esto no se ve
  // para nadie salvo que se fuerce con ?croswatch=1 (se recuerda con
  // localStorage para no tener que repetir el parámetro en cada página).
  var ENABLE_PARAM = 'croswatch';
  var ENABLE_KEY = 'croSwatchImgEnabled';
  (function initSwitch() {
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.has(ENABLE_PARAM)) {
        var on = qs.get(ENABLE_PARAM) === '1';
        localStorage.setItem(ENABLE_KEY, on ? '1' : '0');
      }
    } catch (e) {}
  })();

  // Prioridad fuera del editor: si esta sesión forzó el switch por URL
  // (?croswatch=1 o 0), esa elección manda. Si no, se usa el ajuste del
  // Personalizador (Tests CRO).
  function isEnabled() {
    if (inThemeEditor()) { return settingEnabled(); }
    try {
      var forced = localStorage.getItem(ENABLE_KEY);
      if (forced === '1') { return true; }
      if (forced === '0') { return false; }
    } catch (e) {}
    return settingEnabled();
  }

  // Diseño en móvil de las opciones (Sabor, Cantidad, Formato): grid o
  // carrusel horizontal. Independiente del switch de arriba, porque afecta
  // también a Cantidad/Formato aunque el swatch de imagen esté desactivado.
  var LAYOUT_PARAM = 'crolayout';
  var LAYOUT_KEY = 'croSwatchLayout';
  var LAYOUT_CLASS = 'cro-layout-carousel';
  (function initLayout() {
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.has(LAYOUT_PARAM)) {
        localStorage.setItem(LAYOUT_KEY, qs.get(LAYOUT_PARAM) === 'carousel' ? 'carousel' : 'grid');
      }
    } catch (e) {}
  })();
  function layoutIsCarousel() {
    if (inThemeEditor()) { return settingLayout() === 'carousel'; }
    try {
      var forced = localStorage.getItem(LAYOUT_KEY);
      if (forced === 'carousel') { return true; }
      if (forced === 'grid') { return false; }
    } catch (e) {}
    return settingLayout() === 'carousel';
  }
  function applyLayoutClass() {
    document.documentElement.classList.toggle(LAYOUT_CLASS, layoutIsCarousel());
  }

  var TILE = 240;
  var done = 'croSwatchDone';

  function cdn(url) {
    if (!url) { return ''; }
    if (url.indexOf('/cdn/') === -1 && url.indexOf('cdn.shopify') === -1) { return url; }
    return url.indexOf('?') === -1 ? url + '?width=' + TILE : url + '&width=' + TILE;
  }

  function json(path) {
    var key = 'croSwatch:' + path;
    try {
      var hit = sessionStorage.getItem(key);
      if (hit) { return Promise.resolve(JSON.parse(hit)); }
    } catch (e) {}
    return fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        try { if (d) { sessionStorage.setItem(key, JSON.stringify(d)); } } catch (e) {}
        return d;
      })
      .catch(function () { return null; });
  }

  function decorate(el, label, image, color) {
    if (!image && !color) { return; }        // sin dato real, se deja como está
    if (el.dataset[done] === '1') { return; } // idempotente
    el.dataset[done] = '1';
    el.classList.add('cro-swatch--img');
    if (CFG.size !== 88) { el.style.setProperty('--cro-swatch-size', CFG.size + 'px'); }

    var tile = document.createElement('span');
    tile.className = 'cro-swatch-tile';
    if (color) { tile.style.background = color; }
    if (image) {
      var img = document.createElement('img');
      img.className = 'cro-swatch-img';
      img.src = image;
      img.alt = '';
      img.setAttribute('role', 'presentation');
      // eager a propósito: en móvil el selector cae bajo el pliegue y con carga
      // diferida las baldosas se veían como color plano hasta hacer scroll.
      img.loading = 'eager';
      img.decoding = 'async';
      img.setAttribute('fetchpriority', 'low');
      img.width = TILE;
      img.height = TILE;
      tile.appendChild(img);
    }
    var name = document.createElement('span');
    name.className = 'cro-swatch-name';
    name.textContent = label;

    el.textContent = '';
    el.appendChild(tile);
    el.appendChild(name);
  }

  // Comparación insensible a mayúsculas: la etiqueta bonita del swatch
  // (data-option-display) no siempre coincide en case con el valor crudo
  // que Shopify guarda en product.variants[i].options (p.ej. "Cafeína" en
  // el swatch vs "cafeína" en el JSON del producto para el mismo sabor).
  function norm(s) {
    return (s || '').trim().toLowerCase();
  }

  // Ilustración de sabor sustituyendo la foto real, solo para el swatch.
  // Es una decisión de estilo del test, no un respaldo por falta de dato:
  // 226ers tiene foto real de variante en el 100% de sus sabores, así que
  // esto gana a la foto real solo si hay una ilustración preparada para
  // ese sabor; si no, sigue usándose la foto real de siempre.
  function imageOverride(label) {
    var map = settingOverrides();
    var key = norm(label);
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k) && norm(k) === key) { return map[k]; }
    }
    return '';
  }

  function paintVariants(product) {
    if (!product || !product.variants) { return; }
    document.querySelectorAll(CFG.optionSwatch).forEach(function (el) {
      var label = CFG.label(el);
      if (!label) { return; }
      var key = norm(label);
      var image = cdn(imageOverride(label));
      if (!image) {
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          if (!v.options || !v.featured_image) { continue; }
          var match = false;
          for (var j = 0; j < v.options.length; j++) {
            if (norm(v.options[j]) === key) { match = true; break; }
          }
          if (match) { image = cdn(v.featured_image.src); break; }
        }
      }
      decorate(el, label, image, CFG.colorMap[label] || '');
    });
    var row = document.querySelector(CFG.optionRow);
    if (row) {
      var box = row.querySelector('.cro-swatch--img');
      if (box && box.parentElement) { box.parentElement.classList.add('cro-swatches--img'); }
    }
  }

  function paintFamily() {
    if (!CFG.familySwatch) { return; } // sin patrón de productos hermanos en esta tienda
    var links = document.querySelectorAll(CFG.familySwatch);
    if (!links.length) { return; }
    links.forEach(function (el) {
      var label = CFG.label(el);
      var path = (el.getAttribute('href') || '').split('?')[0];
      if (!label || !path) { return; }
      json(path).then(function (p) {
        var image = '';
        if (p) {
          if (p.featured_image) { image = cdn(p.featured_image); }
          else if (p.images && p.images.length) { image = cdn(p.images[0]); }
        }
        decorate(el, label, image, CFG.colorMap[label] || '');
      });
      var box = el.parentElement;
      if (box) { box.classList.add('cro-swatches--img'); }
    });
  }

  function run() {
    if (!isEnabled()) { return; }
    if (!document.querySelector(CFG.optionSwatch) && !(CFG.familySwatch && document.querySelector(CFG.familySwatch))) { return; }
    var path = window.location.pathname.split('?')[0];
    if (path.indexOf('/products/') === -1) { return; }
    json(path).then(paintVariants);
    paintFamily();
  }

  function tick() {
    try { applyLayoutClass(); } catch (e) {}
    try { run(); } catch (e) {}
  }

  function boot() {
    tick();
    // El theme re-renderiza el bloque al cambiar de variante o de hermano,
    // y el editor al cambiar un ajuste del bloque: en los dos casos hay que
    // releer los ajustes y repintar, no solo la primera vez.
    var mo = new MutationObserver(function () { tick(); });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
